//import { useContext } from "react";
//import AuthContext from "../context/auth-context";

export const PermissionCheck = (permission, items) => {
  //const authCtx = useContext(AuthContext);
  //let items = [...authCtx.permissionList];

  let exist = items.filter((i, index) => {
    return i.codename === permission;
  });
  return exist.length > 0;
};
